import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  input {
    border-radius: 10px;
  }
`

export default Styled
